import { render, staticRenderFns } from "./CmgStarStrip.vue?vue&type=template&id=09397a1d&scoped=true&lang=pug&"
import script from "./cmg-star-strip.ts?vue&type=script&lang=ts&"
export * from "./cmg-star-strip.ts?vue&type=script&lang=ts&"
import style0 from "./CmgStarStrip.vue?vue&type=style&index=0&id=09397a1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09397a1d",
  null
  
)

export default component.exports